<template lang="pug">
  a(:class='lang', :href='path')
    #footerlogo
      img#logo_mark(alt='', width='60', height='30', src='images/img_logo-mark.png')
      p.sitename
        | MEDITECH FINDER
      p.copyright
        | Copyright © 2015 Meditech Finder.
</template>
<script>
  import {mapState} from 'vuex';

  export default {
    data: function(){
      return {
        ja_path: '/',
        en_path: '/en/'
      }
    },
    computed: {
      ...mapState([
        'lang'
      ]),
      path: function(){
        if(/ja/.test(this.lang)){
          return this.ja_path;
        }else{
          return this.en_path;
        }
      },
    }

  };

</script>
<style lang="sass">
  #footerlogo
    position: relative
    & #logo_mark
      position: absolute
      top: 0
      left: 0
    & p
      position: absolute
      &.sitename
        font-weight: 400
        font-size: 1.4em
        top: 1px
        left: 71px
      &.copyright
        top: 20px
        left: 71px
</style>